<template>
  <div>
    <b-row class="pt-3 pb-2">
      <b-col sm="2 title">{{title || "Título não informado"}}</b-col>
      <b-col sm="10" id="tabPrecoDesk">
        <b-button size="sm" variant="secondary" class="btn-plus btnAdicionar right" @click="trocaTabela()" v-if="btnTabela">Tabela de Preço: {{tabelaSelecionada.descricao || "Selecionar"}}</b-button>
        <b-col sm="3" class="right p-0" v-else><b-button size="sm" variant="secondary" class="btn-plus btnAdicionar right" @click="voltar()">Voltar</b-button></b-col>
      </b-col>
    </b-row>
    <b-row class="input-search filtro shadow">
      <b-col cols="10" id="inputFiltroCatalog">
        <b-input-group>
          <b-input-group-prepend>
            <span class="input-group-text"><i class="fa fa-search"></i></span>
          </b-input-group-prepend>
          <b-form-input size="sm" autocomplete="no" :placeholder="placeholderNm" v-model="termo">
          </b-form-input>
        </b-input-group>
      </b-col>
      <b-col cols="1" class="btnLimpaFiltroCatalog">
        <b-button size="sm" v-on:click="limparFiltro()"><i class="fas fa-eraser"></i></b-button>
      </b-col>
      <b-col cols="1" class="btnBuscaFiltroCatalog">
        <b-button size="sm" v-on:click="filtrar()"><i class="fas fa-search"></i></b-button>
      </b-col>
      <!-- <b-col cols="2" size="sm" class="mt-3">
        <b-button size="sm" v-on:click="limparFiltro()"><i class="fas fa-times"></i> Limpar Filtro</b-button>
      </b-col> -->
    </b-row>
    <b-row id="tabPrecoMob" class="mt-2">
      <b-button size="sm" variant="secondary" class="btn-plus btnAdicionar right" @click="trocaTabela()" v-if="btnTabela">Tabela de Preço: {{tabelaSelecionada.descricao || "Selecionar"}}</b-button>
    </b-row>
    <b-modal
      v-model="modalTabPreco"
      ok-variant="primary"
      cancel-title="Fechar"
      cancel-variant="secondary"
      @ok="selecTabPreco"
      :no-close-on-esc=true
      :no-close-on-backdrop=true
      :header-bg-variant="headerBgVariant"
      :header-text-variant="headerTextVariant"> <!--  -->
      <template slot="modal-header">
        <h5>Selecione uma Tabela de Preço</h5>
      </template>
      <b-form-group class="m-0">
        <b-form-select size="sm" v-model="tabelaSelecModal">
          <template slot="first"><option value="" disabled>-- Tabelas --</option></template>
          <option v-for="tabela in this.dadosTabela.tabelasPreco" :value="tabela" :key="tabela.codigo">{{tabela.descricao}}</option>
        </b-form-select>
      </b-form-group>
    </b-modal>
  </div>
</template>
<script>
  import catalogoService from '@/services/tableCatalogo'
  import { broadcastServer } from '@/main' // , operacao, modo
  export default {
    name: 'NewItemsCatalogoVue',
    props: [
      'title',
      'placeholderNm',
      'escondeBtn'
    ],
    components: {
    },
    data () {
      return {
        termo: '',
        btnTabela: true,
        headerTextVariant: 'light',
        headerBgVariant: 'dark',
        modalTabPreco: false,
        // catalogos: catalogos,
        dadosTabela: [],
        tabelaSelecionada: '',
        tabelaSelecModal: ''
      }
    },
    created () {
      catalogoService.listarTabelaDefault().then(response => {
        this.tabelaSelecionada = response.data
        broadcastServer.$emit('tabelaSelecionada', this.tabelaSelecionada)
      }).catch(error => {
        console.log(error)
        alert('Aconteceu alguma coisa!' + error)
      }).finally(() => {
        this.blockUiVisibility = false
      })
      catalogoService.selecionar().then(response => {
        this.blockUiVisibility = true
        this.dadosTabela = response.data
      }).catch(error => {
        console.log(error)
        alert('Aconteceu alguma coisa!' + error)
      }).finally(() => {
        this.blockUiVisibility = false
      })
      broadcastServer.$on('pageViewGrade', parametro => {
        this.termo = ''
      })
    },
    mounted () {
      broadcastServer.$on('esconderBotaoAdicionarCliente', param => {
        this.hideBtn = false
      })
    },
    methods: {
      trocaTabela: function () {
        this.modalTabPreco = true
      },
      selecTabPreco: function () {
        this.tabelaSelecionada = this.tabelaSelecModal
        this.modalTabPreco = false
        broadcastServer.$emit('tabelaSelecionada', this.tabelaSelecionada)
      },
      voltar: function () {
      },
      filtrar: function () {
        broadcastServer.$emit('filtroCatalogo', this.termo)
      },
      limparFiltro: function () {
        this.termo = ''
        broadcastServer.$emit('filtroCatalogo', '')
      }
    }
  }
</script>
<style scoped>
  .btnAdicionar {
    width: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/items/NewItemsCatalogoVue.vue